import store from "../store/store";

const siteText = store.getters["siteText"];

function showErrorMessage(error, allowRefresh, allowClose) {
  let message = error.message;
  if (
    error.message.toLowerCase() === "network error" ||
    error.message.toLowerCase() === "request aborted"
  ) {
    message = siteText.errors.networkError;
  } else if (error.Response && error.Response.status === 401) {
    message = siteText.errors.loginExpired;
  }
  store.dispatch("setSystemError", {
    message: message,
    allowRefresh: allowRefresh,
    allowClose: allowClose,
  });
  store.dispatch("clearBusy");
}

function showSessionTimeout() {
  let message = siteText.errors.loginExpired;
  store.dispatch("setSystemError", {
    message: message,
    allowRefresh: true,
    allowClose: false,
  });
  store.dispatch("clearBusy");
  setTimeout(() => {
    store.dispatch("setSystemError", {
      message: "",
    });
    store.dispatch("finished");
  }, 5000);
}

export default {
  showErrorMessage,
  showSessionTimeout,
};
